module.exports = __webpack_public_path__ + "static/media/tube.07e8327c.svg";